<template>
  <div>
    <el-button type="success" style="margin-bottom: 5px;margin-left: 5px" @click="addGoodsTry">
      上传资料<i class="el-icon-upload el-icon--right"></i>
    </el-button>
    <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="ID"
          label="ID"
          width="80">
      </el-table-column>

      <el-table-column
          prop="Subject"
          label="学科名称">
      </el-table-column>

      <el-table-column
          prop="Name"
          label="资料名称"
          width="200">
      </el-table-column>

      <el-table-column
          label="操作"
          width="120">
        <template slot-scope="scope">
          <el-button @click="cGoods(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog
        title="上传资料"
        :visible="addGoodsVisible"
        width="30%"
        center
        :before-close="addGoodsTryClose"
    >

      <el-form :model="addGoodsForm">

        <el-form-item label="学科名称">
          <el-select v-model="addGoodsForm.name" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.Name"
                :label="item.Name"
                :value="item.Name">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item >

          <el-upload
              class="upload-demo"
              :on-change="httpRequest"
              drag
              :limit="1"
              ref="upload"
              action=""
              :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>

        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="addGoods">确定</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>
import http from "@/utils/http-base";
export default {
  name: "admin-lanmu",
  data(){
    return{
      tableData: [],
      addGoodsVisible: false,
      addGoodsForm:{
        name:"",
      },
      options: [{
        Name: '黄金糕'
      }],
      fileLis:[]

  }
  },
  methods:{
    httpRequest(f,fL) {
      this.fileLis=fL
    },

    getXuke() {
      http.get("/api/down/xueke", ).then(res=>{
        if (res.data.code ===0){
          this.options=res.data.data
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    addGoodsTry() {
      this.addGoodsVisible = true
      this.getXuke()
    },

    addGoods() {
      let formData = new FormData()
      formData.append("subject",this.addGoodsForm.name)

      this.fileLis.forEach((x) => {
        formData.append('file', x.raw)
      })


      http.post("/api/down/fileadd", formData).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          this.addGoodsVisible = false
          this.getGoods()
          this.$refs.upload.clearFiles()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getGoods() {
      http.get("/api/down/file", ).then(res=>{
        if (res.data.code ===0){
          this.tableData=res.data.data
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    cGoods(name) {
      console.log(name,123)
      http.post("/api/down/filedel",{"name":name.Name}, ).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
          this.getGoods()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },

    addGoodsTryClose(){
      this.addGoodsVisible = false
    },
  },
  mounted() {
    this.getGoods()
  }

}
</script>

<style scoped>

</style>